module.exports = __webpack_public_path__ + "static/img/1-4.6763a43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202109/1-4.png
// module id = m+QV
// module chunks = 0